module.exports = __webpack_public_path__ + "static/media/politica-privacidade.a6962295.pdf";